import { render, staticRenderFns } from "./IdeasTab.vue?vue&type=template&id=1a824cec&scoped=true&"
import script from "./IdeasTab.vue?vue&type=script&lang=js&"
export * from "./IdeasTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a824cec",
  null
  
)

export default component.exports